"use client";
/*
 * Documentation:
 * TagEscalationStatus — https://app.subframe.com/ae91faa555e6/library?component=TagEscalationStatus_77cc5f2c-d8fc-48c9-b3c6-1436e7bf0cf1
 */

import React from "react";
import * as SubframeUtils from "../utils";
import * as SubframeCore from "@subframe/core";

interface TagEscalationStatusRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  variant?:
    | "no-data"
    | "pending"
    | "alert"
    | "success"
    | "dismissed"
    | "success-2"
    | "alert-2"
    | "expired"
    | "alert-0"
    | "none";
  score?: React.ReactNode;
  className?: string;
}

const TagEscalationStatusRoot = React.forwardRef<
  HTMLElement,
  TagEscalationStatusRootProps
>(function TagEscalationStatusRoot(
  {
    variant = "no-data",
    score,
    className,
    ...otherProps
  }: TagEscalationStatusRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/77cc5f2c flex h-6 items-center gap-1 rounded-full bg-neutral-100 px-2",
        {
          "bg-transparent": variant === "none" || variant === "alert-2",
          "bg-error-600": variant === "alert-0",
          "bg-neutral-50": variant === "expired" || variant === "dismissed",
          "bg-default-background": variant === "success-2",
          "bg-[#ecfdf3ff]": variant === "success",
          "bg-[#fff1f0ff]": variant === "alert",
          "bg-warning-50": variant === "pending",
        },
        className
      )}
      ref={ref as any}
      {...otherProps}
    >
      <SubframeCore.Icon
        className={SubframeUtils.twClassNames(
          "text-body font-body text-default-font",
          {
            hidden:
              variant === "success" ||
              variant === "alert" ||
              variant === "pending",
          }
        )}
        name={null}
      />
      {score ? (
        <span
          className={SubframeUtils.twClassNames(
            "text-label font-label text-default-font",
            {
              "text-subtext-color": variant === "none",
              "text-white": variant === "alert-0",
              "text-neutral-700":
                variant === "expired" || variant === "dismissed",
              "text-error-700": variant === "alert-2" || variant === "alert",
              "text-[#067647ff]":
                variant === "success-2" || variant === "success",
              "whitespace-nowrap text-warning-700": variant === "pending",
            }
          )}
        >
          {score}
        </span>
      ) : null}
    </div>
  );
});

export const TagEscalationStatus = TagEscalationStatusRoot;
